import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { validateForm } from "utils/validation";
import { CurrencyRules } from "validation/ValidationRules";
import { getCurrencyById, updateCurrency } from "adminApi/CurrencyListApi/CurrencyList";
import CurrencyEditForm from "./Componate/CurrencyEditForm";
import fields from "../json/CurrencyFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

/**
 * CurrencyEdit Component
 * Manages fetching existing currency data and submitting updates for production-grade system settings.
 */
const CurrencyEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Initialize form state using JSON configuration
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: field.default || "" }),
    {}
  );

  const { values, errors, handleChange, setValues } = useFormChange(
    initialValues,
    CurrencyRules
  );

  /**
   * Data Retrieval Logic
   * Fetches existing record by ID and populates the form state.
   */
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getCurrencyById,
    setValues
  );

  /**
   * Update Submission Workflow
   */
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      //  Send the ID and the pure data object separately as expected by refactored API
      return await updateCurrency({
        currencyid: id,
        data: formValues,
      });
    },
    (vals) => validateForm(vals, CurrencyRules),
    () => navigate(-1),
    "Currency updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <CurrencyEditForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Currency Setting"
        setValues={setValues}
      />
    </>
  );
};

export default CurrencyEdit;
